import { type ChannelBase, getChannelBaseData } from 'models';
import { useInfiniteQuery } from 'query';
import { getChannels } from '../services';
import { getChannelsQueryKey } from './keys';

type P = {
  organizationId?: string;
  pageSize: number;
};

export const useChannelsInfiniteQuery = ({ organizationId, pageSize }: P) =>
  useInfiniteQuery<ChannelBase[], number>({
    async queryFn({ pageParam: pageParameter }) {
      const response = await getChannels({
        limit: pageSize,
        offset: pageParameter,
        organization_id: organizationId,
      });

      return response.data.map((entity) => getChannelBaseData(entity));
    },
    initialPageParam: 0,
    getNextPageParam(lastPage, allPages) {
      return lastPage.length < pageSize ? undefined : allPages.length * pageSize;
    },
    queryKey: getChannelsQueryKey({ organizationId, pageSize }),
  });
